// Module
var code = `<div class="modal panel"> Pay prompt </div>`;
// Exports
export default code;